import {GETCOUNTRYDATA} from './urls';
import { conn } from './conn';
import {fmtNum} from '../tools/tools';
import {localStorageSave,localStorageLoad} from './localStorage';


/*
[
  {country:String (country name), data:[(array of data (arrayOrder))]}
]
*/
const defaultCountryAPIDataKey='defaultCountryAPIData';

const getCountryData = async ({country,topics=[]})=>{
  let url=GETCOUNTRYDATA(country);
  const topicsQuery=topics.join('&topics[]=');
  url+='?topics[]='+topicsQuery;

  const { data } = await conn().get(url);

  
  
  /*
  return format:
    {
      country:(country name),
      topics:[
        {value:(value itself),date:'',code:(worldbank code),topic:(topic name)}
      ]
    }
*/
  return data;
}



// Get the always required api data: (always required even if there are no such topics)
/*
  'Population, total',
  'Ease of doing business',
  'GDP (Current US$)',
  'GDP Per Capita (Current US$)',
*/
const getDefaultCountryData = async ({
  country,
  setStatus=()=>false // just in case the calling component wants to set some 'loading' status
})=>{


  const arrayOrder=[
    'Population, total',
    'Ease of doing business',
    'GDP (Current US$)',
    'GDP Per Capita (Current US$)',
    'Capital',
    'Currency',
    'Language',
    'Region'
  ];


  // getting from localstorage
  const local=localStorageLoad(defaultCountryAPIDataKey);
  if(local) {
    const ret=local.find(elem=>elem.country===country);

    // we got from localstorage, but is there all that?
    if(ret && ret.data) {
      const trueDataQtd=ret.data.reduce((accum,curr)=>{
        if(curr) {
          accum++;
        }
        return accum;
      },0);
      
      
      if(ret && (trueDataQtd === arrayOrder.length)) {
        return {
          arrayData:ret.data
        };
      }
    }
  }

  setStatus('loading');
  const data = await getCountryData({country,topics:[
    'Ease of doing business',
    'Population, total',
    'GDP (Current US$)',
    'GDP Per Capita (Current US$)',
    'Capital',
    'Currency',
    'Language',
    'Region'
  ]});



  // topic with num to be formatted
  const toFmtNum=[
    'Population, total',
    'Ease of doing business',
    'GDP (Current US$)',
    'GDP Per Capita (Current US$)',
  ]

  const arrayData=arrayOrder.map((elem)=>{
    const dataItem=data.topics.find(topic=>topic.topic===elem);
    let ret=dataItem.value;
    if(toFmtNum.includes(elem)) {
      ret=fmtNum(ret);
    }
    return ret;
  });


  // saving in storage
  let toSave={
    country,
    data:arrayData
  }
  if(local) {
    local.push({...toSave});
    toSave=local;
  } else {
    toSave=[{...toSave}];
  }

  localStorageSave({
    [defaultCountryAPIDataKey]:toSave
  })

  setStatus('');

  return {
    data,
    arrayData
  };
}




// get template's topics data
const getTemplateTopicsData = async (template)=>{
  const {categories,country}=template;

  if(!country) {
    throw new Error('(getTemplateTopicsData) - No country!');
  }

  const data2Get=[];

  if(categories) {
    categories.forEach(cat=>{
      const {topics}=cat;
      if(topics) {
        topics.forEach(elem=>{
          const {topic,information}=elem;
          if(!information) {
            data2Get.push({topic});
          }
        });
      }
    });
  }

  // return format:
  /*
    [{value:(value itself),date:'',code:(worldbank code),topic:(topic name)}]
  */
  let ret=[]

  // getting data
  if(data2Get.length) {
    const topicsArray=data2Get.map(elem=>elem.topic);
    const apiData = await getCountryData({country,topics: topicsArray});
    if(apiData && apiData.topics) {
      ret=apiData.topics;
    }
  }

  return ret;
}


const injectAPIDataInTemplate=(template={},apiData=[])=>{
  if(template.categories) {
    template.categories.forEach(cat=>{
      cat.topics.forEach(elem=>{
        const {topic}=elem;
        const dataTopic=apiData.find(elem=>elem.topic===topic);
        if(dataTopic && dataTopic.value) {
          elem.information=dataTopic.value;
        }
      });
    });
  }

  return template;
}


export {
  getCountryData,
  getDefaultCountryData,
  getTemplateTopicsData,
  injectAPIDataInTemplate
}